import React from 'react';
import './BoardsOverview.css';
/**
 * The boards-home scope filter: All · Personal · one segment per team, each
 * with its board count in muted text (card 7.2: the same segmented control as
 * the Kanban/List switch). Single-select, so each segment is a toggle button
 * (`aria-pressed`) in a labelled group.
 *
 * Renders nothing when there are no chips (no team boards): see scopeChips().
 */
export default function BoardsScopeChips({ chips, selected, onSelect }) {
  if (!chips || chips.length === 0) return null;
  return (
    <div className="boards-seg" role="group" aria-label="Filter boards by team">
      {chips.map((c) => {
        const on = c.key === selected;
        return (
          <button
            key={c.key}
            type="button"
            className={`boards-seg-btn${on ? ' boards-seg-btn--on' : ''}`}
            aria-pressed={on}
            onClick={() => onSelect(c.key)}
          >
            {c.label}{' '}
            <span className="boards-seg-count">{c.count}</span>
          </button>
        );
      })}
    </div>
  );
}
